import router from './router';
import store from './store';
import cache from './utils/cache';

router.beforeEach((to, from, next) => {
    // 获取路由meta中的title，并设置给页面标题
    document.title = to.meta.title;
    // 获取用户登录信息
    const token = store.getters.getTk;
    const tokenValid = (new Date().getTime() - store.getters.getTkt) < 8 * 3600 * 1000;

    // 判断该路由是否需要登录权限
    if (to.meta.requireAuth) {
        if (token && token != "undefined" && tokenValid) {    // 已经登录，跳转至路由页面
            // 存储页面名称
            store.dispatch("setPageName", to.meta.title.split("-")[0]);
            next();
        } else {    // 未登录，跳转至登录页面
            // 清除缓存信息
            cache.clear();
            next({ path: '/' })
        }
    } else {     // 不需要权限校验，进入路由页面
        next();
    }
});



// WEBPACK FOOTER //
// ./src/permission.js